import { LogSourceList } from '../types';

export type SetLogSourcesAction = {
  type: 'set_log_sources';
  logSources: LogSourceList;
};

export type SetLogSourcesLoadingAction = {
  type: 'set_log_sources_loading';
  isLoading: boolean;
};

export type SetReservedTagsAction = {
  type: 'set_reserved_log_tags';
  tags: Array<string>;
};

export type SetReservedTagsLoadingAction = {
  type: 'set_reserved_log_tags_loading';
  isLoading: boolean;
};

export type LogSourceAction =
  | SetLogSourcesAction
  | SetLogSourcesLoadingAction
  | SetReservedTagsAction
  | SetReservedTagsLoadingAction;

export const LOGS_ACTIONS = {
  SET_LOG_SOURCES: (logSources: LogSourceList): SetLogSourcesAction => ({
    type: 'set_log_sources',
    logSources,
  }),
  SET_LOG_SOURCES_LOADING: (
    isLoading: boolean,
  ): SetLogSourcesLoadingAction => ({
    type: 'set_log_sources_loading',
    isLoading,
  }),
  SET_RESERVED_TAGS: (tags: Array<string>): SetReservedTagsAction => ({
    type: 'set_reserved_log_tags',
    tags,
  }),
  SET_RESERVED_TAGS_LOADING: (
    isLoading: boolean,
  ): SetReservedTagsLoadingAction => ({
    type: 'set_reserved_log_tags_loading',
    isLoading,
  }),
};
